import { gql } from "@apollo/client";

export const PARCEL_INVOICES_BY_ORDER_IDS = gql`
  query parcelInvoicesByOrderIds($projectId: ID!, $orderIds: [ID]!, $type: ParcelInvoiceTemplateType) {
    parcelInvoicesByOrderIds(projectId: $projectId, orderIds: $orderIds, type: $type)
  }
`;
